import {VehicleForm as VFKit} from '../VehicleForm';

export function WeightGroup() {
  return (
    <>
      <VFKit.SimpleNumericField name="operatingWeight" />
      <VFKit.SimpleNumericField name="weight" />
      <VFKit.SimpleNumericField name="maximalLoadCapacity" />
    </>
  );
}
